import React from "react";
import "./Linktree.css";

// Імпортуємо зображення
import logo1 from "../../img/logo_1_color.png";
import logo2 from "../../img/logo_2_color.png";
import logo3 from "../../img/logo_3_color.png";

const fahrschulen = [
  {
    id: "hafencity",
    title: "Hafencity",
    link: "https://fahrschule-hafencity.de/",
    color: "#D1EAFF", // blue
    logo: logo3,
  },
  {
    id: "bergedorf",
    title: "Bergedorf",
    link: "https://fahrschule-bergedorf.de/",
    color: "#B6FF8D", // green
    logo: logo1,
  },
  {
    id: "geesthacht",
    title: "Geesthacht",
    link: "https://www.geesthacht-fahrschule.de/",
    color: "#FFE3E9", // red
    logo: logo2,
  },
];

export default function Linktree() {
  return (
    <div className="linktree-container">
      {fahrschulen.map((fahrschule) => (
        <a
          key={fahrschule.id}
          href={fahrschule.link}
          className={`linktree-section linktree-${fahrschule.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="linktree-content">
            <div className="linktree-logo" data-aos="zoom-in">
              <img
                src={fahrschule.logo}
                alt={`Fahrschule ${fahrschule.title}`}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </div>
          </div>
          <div className="linktree-overlay"></div>
        </a>
      ))}
    </div>
  );
}
